/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type HumanCardAttachment = {
    readonly id: number;
    /**
     * Attachment name, up to 256 characters
     */
    name?: string;
    /**
     * Extended description, up to 2048 characters
     */
    comment?: string;
    /**
     * Attachment file
     */
    file: string;
    /**
     * File size
     */
    readonly size: number;
    /**
     * Object creation date
     */
    readonly created_date: string;
    card: number;
};
export const EmptyHumanCardAttachment: HumanCardAttachment = {
    id: 0,
    /**
     * Attachment name, up to 256 characters
     */
    name: '',
    /**
     * Extended description, up to 2048 characters
     */
    comment: '',
    /**
     * Attachment file
     */
    file: '',
    /**
     * File size
     */
    size: 0,
    /**
     * Object creation date
     */
    created_date: '',
    card: 0,
};